import React from 'react';
import AdminLayout from '../../component/AdminCompo/AdminLayout';

export default function AdminSkills() {
  return (
    <AdminLayout title="Skills" subtitle="Skills editing tools can live here.">
      <div className="admin-card p-6">
        <p className="text-slate-500">Skills section is ready for your next update.</p>
      </div>
    </AdminLayout>
  );
}
